import i18n from './i18n/index';
import HttpClient from '../../search-library/src/utils/http';
import { logger } from './utils/logger';
import { getLocale } from './utils/helpers';
import { Vue, Component } from 'vue-property-decorator';
import { categorySuggestions } from './services/suggestions/categories/categorySuggestions';
import { suggestions } from './services/suggestions/simple/suggestions';
import { Stage, STAGES, environment } from '../../search-library/src/config/environment';
import { SessionsService } from '../../search-library/src/services/sessions/sessionsService';
import { getSearchProfileByLocale, getConfigBySearchProfile } from '../../search-library/src/config/market-config';
import { mutations } from './state/store';

@Component
export class AppBase extends Vue {
  private init(country: string, language: string, searchProfile: string, stage: string): void {
    const locale = getLocale(country, language);
    categorySuggestions.init(searchProfile);
    suggestions.init(searchProfile);
    i18n.locale = locale;
    logger.log('i18n library locale changed to', i18n.locale);

    environment.stage = stage ? (stage.toLowerCase() as Stage) : STAGES.TEST;

    // Set AEM-related config
    HttpClient.setDetfaults(environment.fssCoreApiUrl, country, language);

    logger.log('Setting session token');
    SessionsService.getToken();
  }

  initWithSearchProfile(searchProfile: string, stage: string): void {
    const { language, market: country, features, versions } = getConfigBySearchProfile(searchProfile);

    mutations.setFeatures(features);
    mutations.setVersions(versions);
    this.init(country, language, searchProfile, stage);
  }

  initWithMarketConfig(country: string, language: string, stage: string): void {
    const searchProfile = getSearchProfileByLocale(getLocale(country, language));
    const { features, versions } = getConfigBySearchProfile(searchProfile);
    logger.debug('Create elements: ', features, versions);

    mutations.setFeatures(features);
    mutations.setVersions(versions);
    this.init(country, language, searchProfile, stage);
  }
}
